import { useEffect, useState } from "react";
import { Skeleton } from "@mui/material";
import { Image } from "../../services/shirts/types";
import FormatService from "../../services/formatService";
import ImageView from "../ImageView/ImageView";

interface ImagePreviewProps {
  image: Image;
  removeImage?: Function;
  index: number;
  height?: number;
  width?: number;
}

/**
 * Image Preview component used to view the image before upload it
 */
export const ImagePreview = ({
  image,
  index,
  removeImage,
  width,
  height,
}: ImagePreviewProps) => {
  const [imageUrl, setImageUrl] = useState<string | undefined>(undefined);
  const { b64toBlob } = FormatService();

  useEffect(() => {
    if (image.data) {
      const blob = b64toBlob(image.data);
      const blobUrl = URL.createObjectURL(blob);
      setImageUrl(blobUrl);
    } else {
      if (image.url) {
        setImageUrl(image.url);
      }
    }
  }, [image]);

  return imageUrl ? (
    <ImageView
      index={index}
      removeImage={removeImage}
      url={imageUrl}
      width={width}
      height={height}
    />
  ) : (
    <Skeleton variant="rectangular" width={200} height={200} />
  );
};

export default ImagePreview;
